<template>
  <v-row class="selection-container">
    <v-col>
      <v-card
        outlined
        rounded
        class="pay-box selection d-flex justify-center align-center flex-column"
        :ripple="false"
        @click="$emit('update:dividePayment', 'todo')"
      >
        <!-- <font-awesome-icon
          icon="shopping-cart"
          :style="{ color: '#000000', fontSize: 50 }"
        /> -->
        <div
          class="icon-box"
          :class="[{ 'active-card': dividePayment === 'todo' }]"
        >
          <img :src="`${VUE_APP_BASE_URL}/img/svg/shopping-card.svg`" />
        </div>
        <span class="mt-1">{{ $t("common.everything") }}</span>
      </v-card>
    </v-col>
    <v-col>
      <v-card
        outlined
        rounded
        class="pay-box selection d-flex justify-center align-center flex-column"
        :ripple="false"
        @click="$emit('update:dividePayment', 'amount')"
      >
        <!-- <font-awesome-icon
          icon="divide"
          :style="{ color: '#000000', fontSize: 50 }"
        /> -->
        <div
          class="icon-box"
          :class="[{ 'active-card': dividePayment === 'amount' }]"
        >
          <img :src="`${VUE_APP_BASE_URL}/img/svg/divider.svg`" />
        </div>
        <span class="mt-1">{{ $t("modal.splitAccount") }}</span>
      </v-card>
    </v-col>
    <v-col>
      <v-card
        outlined
        rounded
        class="pay-box selection d-flex justify-center align-center flex-column"
        :ripple="false"
        @click="$emit('update:dividePayment', 'product')"
      >
        <!-- <font-awesome-icon
          icon="drumstick-bite"
          :style="{ color: '#000000', fontSize: 50 }"
        /> -->
        <div
          class="icon-box"
          :class="[{ 'active-card': dividePayment === 'product' }]"
        >
          <img :src="`${VUE_APP_BASE_URL}/img/svg/list.svg`" />
        </div>
        <span class="mt-1">{{ $t("modal.byProducts") }}</span>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DevideOrProducts",
  props: ["dividePayment"],
  data() {
    return {
      VUE_APP_BASE_URL: process.env.VUE_APP_BASE_URL
    };
  }
};
</script>

<style lang="scss">
.selection-container {
  .pay-box {
    border: 0;
    &::before {
      background-color: transparent;
    }
    .icon-box {
      width: 130px;
      height: 130px;
      margin: auto;
      border-radius: 50% !important;
      box-shadow: 0 0 10px 1px #000;
      &.active-card {
        background: #e8e8e8;
      }
      @media screen and (max-width: 575px) {
        width: 110px;
        height: 110px;
      }
      @media screen and (max-width: 480px) {
        width: 80px;
        height: 80px;
      }
      @media screen and (max-width: 380px) {
        width: 70px;
        height: 70px;
      }
      @media screen and (max-width: 350px) {
        width: 65px;
        height: 65px;
      }
      @media screen and (max-width: 330px) {
        width: 60px;
        height: 60px;
      }
      img {
        width: 120px;
        margin: auto;
        margin-top: 5px;
        @media screen and (max-width: 575px) {
          width: 100px;
        }
        @media screen and (max-width: 480px) {
          width: 80px;
          margin-top: 0;
        }
        @media screen and (max-width: 380px) {
          width: 70px;
        }
        @media screen and (max-width: 350px) {
          width: 65px;
        }
        @media screen and (max-width: 330px) {
          width: 60px;
        }
      }
    }
    @media screen and (max-width: 480px) {
      span {
        font-size: 12px;
        text-align: center;
        line-height: normal;
      }
    }
  }
  .selection {
    cursor: pointer;
  }
}
</style>
